// Single source of the panel version shown in the sidebar and sent with support requests.
export const PANEL_VERSION = '5.0.184';
